export default __webpack_public_path__ + "static/media/insta.512b3c19.svg";